<template>
  <div class="Model">
    <Modal
      v-model="nextStatus"
      title="下次执行时间"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
     <ul v-if="cronList.length > 0">
       <li v-for="(item, index) in cronList" :key="index">{{ item }}</li>
     </ul>
     <p v-else>暂无数据</p>
    <!-- 按钮组 -->
    <div class="btn-box">
      <Button class="ys-confirm" type="primary" @click="ok" style="width: 100px;">确认</Button>
    </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props:{
    nextStatus: {
      type: Boolean,
      default: false
    },
    cronList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  methods:{
    ok (name) {
      this.$emit('handle-next-model', {code: 2})
    }
  },
  mounted() {
    
  }
}
</script>
<style lang="less" scoped>
.btn-box {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin-top: 40px;
}
</style>